export default __webpack_public_path__ + "static/media/dog2.f9eb1be8.png";